export const STAT_PARTS = ['label', 'number', 'icon', 'helpText'] as const;
